/* eslint-disable no-case-declarations */
import axios from 'axios';
import https from 'https';
import {
  buildListParams, buildError, buildGraphQLVariables, buildGraphQLListParams,
} from '../utils/Tools';
import logger from '../logger/logger';
import {
  POST_LOGIN,
  POST_LOGIN_BY_MAGIC_LINK,
  POST_LOGOUT,
  POST_RECOVER_PASSWORD,
  GET_RECOVER_PASSWORD_LINK,
  UPDATE_RECOVER_PASSWORD_LINK,
  GET_ME,
  UPDATE_ME,
  GET_OPERATORS,
  GET_EQUIPMENTS_LIST,
  GET_DEVICE_MODELS,
  GET_DEVICES_LIST,
  GET_DEVICES_AUTOCOMPLETE,
  GET_DEVICE,
  GET_DEVICE_INFO,
  GET_DEVICE_LF,
  GET_DEVICE_SYNC,
  SEND_CMD_DEVICE,
  SEND_DEVICE_SMS,
  GET_DEVICE_SMS_HISTORY,
  GET_DEVICE_SMS_STATUS,
  DELETE_DEVICE,
  UPDATE_DEVICE,
  LINK_DEVICE_SIMCARD,
  UNLINK_DEVICE_SIMCARD,
  UPDATE_DEVICE_CONFIG,
  GET_DEVICE_LOGS_LIST,
  GET_DEVICE_DISTRIBUTIONS_HISTORY,
  GET_DEVICE_SLAVES_LIST,
  GET_DEVICE_SLAVE,
  DELETE_DEVICE_SLAVE,
  UPDATE_DEVICE_SLAVE,
  GET_INSTALLATIONS_LIST,
  GET_INSTALLATIONS_AUTOCOMPLETE,
  ADD_INSTALLATION,
  GET_INSTALLATION,
  GET_INSTALLATION_LF,
  GET_DEVICE_INSTALLATION,
  UPDATE_INSTALLATION,
  DELETE_INSTALLATION,
  GET_INSTALLATION_ENTITIES,
  ADD_INSTALLATION_ENTITY,
  DELETE_INSTALLATION_ENTITY,
  UPDATE_INSTALLATION_ENTITY,
  GET_INSTALLATION_DOORS,
  ADD_INSTALLATION_DOOR,
  DELETE_INSTALLATION_DOOR,
  GET_INSTALLATION_DOOR,
  UPDATE_INSTALLATION_DOOR,
  GET_INSTALLATION_SOURCES,
  ADD_INSTALLATION_SOURCE,
  DELETE_INSTALLATION_SOURCE,
  GET_INSTALLATION_SOURCE,
  UPDATE_INSTALLATION_SOURCE,
  GET_INSTALLATION_DEVICES,
  ADD_INSTALLATION_DEVICE,
  DELETE_INSTALLATION_DEVICE,
  GET_INSTALLATION_DEVICE,
  UPDATE_INSTALLATION_DEVICE,
  REPLACE_INSTALLATION_DEVICE,
  ADD_INSTALLATION_DEVICE_SLAVE,
  GET_INSTALLATION_DEVICE_SLAVE,
  UPDATE_INSTALLATION_DEVICE_SLAVE,
  DELETE_INSTALLATION_DEVICE_SLAVE,
  REPLACE_INSTALLATION_DEVICE_SLAVE,
  GET_INSTALLATION_SCENARIOS,
  ADD_INSTALLATION_SCENARIO,
  DELETE_INSTALLATION_SCENARIO,
  GET_INSTALLATION_SCENARIO,
  UPDATE_INSTALLATION_SCENARIO,
  TRIGGER_INSTALLATION_SCENARIO,
  GET_INSTALLATION_CUSTOMERS_LIST,
  GET_INSTALLATION_CUSTOMERS_AUTOCOMPLETE,
  GET_INSTALLATION_CUSTOMER,
  GET_INSTALLATION_CUSTOMER_LF,
  ADD_INSTALLATION_CUSTOMER,
  UPDATE_INSTALLATION_CUSTOMER,
  UPDATE_INSTALLATION_CUSTOMER_STATE,
  DELETE_INSTALLATION_CUSTOMER,
  GET_INSTALLATION_CUSTOMER_RANDOM_UNIQUE_KEYPAD_CODE,
  GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES,
  EXPORT_INSTALLATION_CUSTOMERS,
  GET_INSTALLATION_CUSTOMER_ACCESSWAYS,
  ADD_INSTALLATION_CUSTOMER_ACCESSWAY,
  UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY,
  DELETE_INSTALLATION_CUSTOMER_ACCESSWAY,
  TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT,
  GET_INSTALLATION_PLANNINGS,
  GET_INSTALLATION_PLANNING,
  ADD_INSTALLATION_PLANNING,
  UPDATE_INSTALLATION_PLANNING,
  DELETE_INSTALLATION_PLANNING,
  GET_INSTALLATION_LOGS_LIST,
  GET_INSTALLATION_ASYNC_OPERATIONS_LIST,
  GET_INSTALLATION_ASYNC_OPERATION_HISTORY,
  GET_SIMCARDS_LIST,
  GET_SIMCARDS_AUTOCOMPLETE,
  ADD_SIMCARDS,
  IMPORT_SIMCARDS,
  GET_SIMCARD,
  GET_SIMCARD_LF,
  UPDATE_SIMCARD,
  DELETE_SIMCARD,
  SYNCHRONIZE_SIMCARDS,
  ACTIVATE_SIMCARDS,
  LINK_SIMCARD_DEVICE,
  UNLINK_SIMCARD_DEVICE,
  GET_SIMCARD_GROUPS_LIST,
  ADD_SIMCARD_GROUP,
  GET_SIMCARD_GROUP,
  ADD_SIMCARD_GROUP_APN,
  DELETE_SIMCARD_GROUP_APN,
  GET_APNS_LIST,
  ADD_APN,
  GET_COMPANIES,
  ADD_COMPANY,
  DELETE_COMPANY,
  GET_COMPANY,
  UPDATE_COMPANY,
  GET_USERS_LIST,
  GET_USER,
  ADD_USER,
  UPDATE_USER,
  DELETE_USER,
  GET_PROFILES_LIST,
  GET_PROFILES_AUTOCOMPLETE,
  GET_PROFILE,
  GET_PROFILE_LF,
  ADD_PROFILE,
  UPDATE_PROFILE,
  DELETE_PROFILE,
  GET_PERMISSIONS,
  GET_ALERTINGS,
  GET_DEVICE_BATCHES,
  ADD_DEVICE_BATCH,
  GET_DEVICE_BATCH,
  UPDATE_DEVICE_BATCH,
  GET_DEVICE_BATCH_AUTHOR,
  GET_DEVICE_BATCH_COMMITTER,
  GET_DEVICE_BATCH_DISTRIBUTION,
  GET_DEVICE_BATCH_ARCHIVE,
  GET_DISTRIBUTIONS_LIST,
  GET_DISTRIBUTIONS_AUTOCOMPLETE,
  GET_DISTRIBUTION,
  GET_DISTRIBUTION_LF,
  ADD_DISTRIBUTION,
  UPDATE_DISTRIBUTION,
  DELETE_DISTRIBUTION,
  GET_DISTRIBUTION_ARCHIVE,
  GET_ROLLOUTS_LIST,
  GET_ROLLOUT,
  ADD_ROLLOUT,
  DELETE_ROLLOUT,
  GET_ROLLOUT_DEVICES_LIST,
  // CPM
  CPM_GET_PRICE_RULES,
  CPM_GET_CARPARKS_AUTOCOMPLETE,
  CPM_GET_CARPARKS_LIST,
  CPM_COUNT_CARPARKS,
  CPM_GET_CARPARK,
  CPM_GET_CARPARK_BY_SLUG,
  CPM_GET_CARPARK_DEFAULT_SLUG,
  CPM_GET_CARPARK_SYNCHRONIZATION_STATUSES,
  CPM_UPDATE_CARPARK,
  CPM_UPDATE_CARPARK_CONTACT,
  CPM_TRIGGER_CARPARK_DOOR,
  CPM_GET_CARPARK_UNIQUE_KEYPAD_CODE,
  CPM_GET_CARPARK_REVENUES_SUMMARY,
  CPM_UPDATE_CARPARK_BOOKING_SETTINGS,
  CPM_UPDATE_CARPARK_GENERAL_SETTINGS,
  CPM_UPDATE_CARPARK_ON_DEMAND_SETTINGS,
  CPM_UPDATE_CARPARK_LICENSE_PLATE_SETTINGS,
  CPM_UPDATE_CARPARK_SPACES_SETTINGS,
  CPM_UPDATE_CARPARK_FINANCIAL_INFORMATION,
  CPM_UPDATE_CARPARK_PARTNER,
  CPM_UPDATE_CARPARK_WORKSPACE_GROUPS,
  CPM_GET_CARPARK_ACTIVITY_ARRIVALS_LIST,
  CPM_GET_CARPARK_ACTIVITY_DEPARTURES_LIST,
  CPM_GET_CARPARK_ACTIVITY_ENTRIES_LIST,
  CPM_GET_CARPARK_ACTIVITY_EXITS_LIST,
  CPM_GET_CARPARK_PLANNINGS,
  CPM_GET_CARPARK_PLANNING,
  CPM_ADD_CARPARK_PLANNING,
  CPM_UPDATE_CARPARK_PLANNING,
  CPM_DELETE_CARPARK_PLANNING,
  CPM_GET_CARPARK_PARKING_CATEGORIES,
  CPM_ADD_CARPARK_PARKING_CATEGORY,
  CPM_UPDATE_CARPARK_PARKING_CATEGORY,
  CPM_DELETE_CARPARK_PARKING_CATEGORY,
  CPM_ADD_CARPARK_PRICE_GRID_TO_PARKING_CATEGORY,
  CPM_DELETE_CARPARK_PRICE_GRID_FROM_PARKING_CATEGORY,
  CPM_SEND_CARPARK_PRICE_GRID_TO_CUSTOMER,
  CPM_GET_CARPARK_PRICE_GRIDS,
  CPM_ADD_CARPARK_PRICE_GRID,
  CPM_UPDATE_CARPARK_PRICE_GRID,
  CPM_GET_CARPARK_CUSTOMERS_LIST,
  CPM_GET_CARPARK_CUSTOMER,
  CPM_GET_CARPARK_CUSTOMERS_AUTOCOMPLETE,
  CPM_GET_CARPARK_CUSTOMER_LF,
  CPM_ADD_CARPARK_CUSTOMER,
  CPM_UPDATE_CARPARK_CUSTOMER,
  CPM_DELETE_CARPARK_CUSTOMER,
  CPM_CREATE_CARPARK_CUSTOMER_ACCOUNT,
  CPM_DELETE_CARPARK_CUSTOMER_ACCOUNT,
  CPM_CHECK_CUSTOMER_ACCOUNT_LINK,
  CPM_VALIDATE_CUSTOMER_ACCOUNT_LINK,
  CPM_VALIDATE_ACCOUNT_LINK,
  CPM_GET_CARPARK_CUSTOMER_PARKINGS_LIST,
  CPM_GET_CARPARK_CUSTOMER_BOOKINGS_LIST,
  CPM_GET_CARPARK_CUSTOMER_OLD_PARKINGS_LIST,
  CPM_GET_CARPARK_CUSTOMER_ACCESSES_LIST,
  CPM_GET_CARPARK_PARKINGS_LIST,
  CPM_GET_CARPARK_PARKINGS_AUTOCOMPLETE,
  CPM_GET_CARPARK_PARKING_LF,
  CPM_ADD_CARPARK_PARKING,
  CPM_UPDATE_CARPARK_PARKING,
  CPM_UPDATE_CARPARK_PARKING_STATE,
  CPM_GET_CARPARK_BOOKINGS_LIST,
  CPM_ADD_CARPARK_BOOKING,
  CPM_CANCEL_CARPARK_BOOKING,
  CPM_SEARCH_CARPARK_BOOKING_OFFER,
  CPM_SEARCH_CARPARK_BOOKING_EXTENSION_OFFER,
  CPM_UPDATE_CARPARK_BOOKING,
  CPM_UPDATE_CARPARK_BOOKING_STATE,
  CPM_SEND_BOOKING_PAYMENT_LINK,
  CPM_REFUND_BOOKING,
  CPM_REFUND_ON_DEMAND_ACCESS,
  CPM_REFUND_PURCHASE,
  CPM_DELETE_CARPARK_PARKING,
  CPM_GET_CARPARK_PARKING_ACCESSES_LIST,
  CPM_GET_CARPARK_ON_DEMAND_LIST,
  CPM_CATEGORIZE_CARPARK_ON_DEMAND,
  CPM_DELETE_CARPARK_ON_DEMAND,
  CPM_GET_ON_DEMAND_ACCESS,
  CPM_UPDATE_CARPARK_ON_DEMAND_ACCESS_STATE,
  CPM_GET_CARPARK_ACCESSES_LIST,
  CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_LIVE,
  CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PERIOD,
  CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PREDICTED,
  CPM_GET_CARPARK_METRICS_ACCESSES,
  CPM_GET_CARPARK_METRICS_REVENUES,
  CPM_GET_CARPARK_METRICS_REVENUES_REPORT,
  CPM_GET_CARPARK_WORKSPACE_GROUPS,
  CPM_RESEND_BOOKING_CONFIRMATION_EMAIL,
  // My Bookings
  CPM_LIST_MY_CARPARK_BOOKING_OPTIONS,
  CPM_BOOK_CARPARK,
  CPM_GET_MY_BOOKINGS_LIST,
  CPM_EXTEND_BOOK_CARPARK,
  CPM_PAY_BOOKING_OVERSTAY,
  CPM_CANCEL_MY_BOOKING,
  CPM_GET_MY_BOOKING,
  CPM_GET_UPDATED_MY_BOOKING,
  CPM_GET_OFFER,
  CPM_DECLARE_FINAL_EXIT_FOR_BOOKING,
  // Onepark booking
  CPM_GET_ONEPARK_BOOKINGS_LIST,
  // Accounts
  CPM_SIGN_UP,
  CPM_GET_ACCOUNTS_LIST,
  CPM_SET_ACCOUNT_STATUS,
  // OnDemand Access
  CPM_SEARCH_ON_DEMAND_ACCESS,
  CPM_SELF_CHECKOUT_ON_DEMAND_ACCESS,
  CPM_EXTEND_ON_DEMAND_ACCESS,
  CPM_PAY_ON_DEMAND_ACCESS_OVERSTAY,
  CPM_CREATE_ON_DEMAND_ACCESS,
  CPM_TERMINATE_ON_DEMAND_ACCESS,
  CPM_UPDATE_ON_DEMAND_ACCESS_CUSTOMER,
  CPM_UPDATE_ON_DEMAND_ACCESS,
  CPM_DECLARE_FINAL_EXIT_FOR_TEMPORARY_ON_DEMAND_ACCESS,
  // Invoices
  CPM_GET_CARPARK_INVOICES_LIST,
  CPM_DOWNLOAD_CARPARK_INVOICE,
  CPM_DOWNLOAD_CARPARK_INVOICES,
  CPM_DOWNLOAD_MY_INVOICE,
  CPM_UPDATE_CARPARK_INVOICE,
  // Partners
  CPM_GET_PARTNERS_LIST,
  CPM_CREATE_PARTNER,
  CPM_UPDATE_PARTNER_FINANCIAL_INFORMATION,
  // Workspace
  CPM_LIST_WORKSPACES,
  CPM_GET_WORKSPACE,
  CPM_CREATE_WORKSPACE,
  CPM_UPDATE_WORKSPACE,
  // Workspace Group
  CPM_LIST_WORKSPACE_GROUPS,
  CPM_GET_WORKSPACE_GROUP,
  CPM_CREATE_WORKSPACE_GROUP,
  CPM_UPDATE_WORKSPACE_GROUP,
  // Service fee rules
  CPM_GET_SERVICE_FEE_RULE,
  CPM_LIST_SERVICE_FEE_RULES,
  CPM_CREATE_SERVICE_FEE_RULE,
  CPM_DELETE_SERVICE_FEE_RULE,
  CPM_UPDATE_SERVICE_FEE_RULE,
  // Slugs
  CPM_LIST_SLUGS,
  CPM_GET_SLUG_BY_DOMAIN,
  CPM_CREATE_SLUG,
  CPM_DELETE_SLUG,
  CPM_UPDATE_SLUG,
  // Payment
  CPM_INITIATE_PAYMENT,
  CPM_DELETE_MY_PAYMENT_METHOD,
} from '../constants/ActionTypes';

/*
** From Webpack Env Config
*/
const API_URL = __API_URL__; // eslint-disable-line no-undef
// const API_URL = 'http://192.168.1.151:4000';

const GRAPHQL_URL = __GRAPHQL_URL__; // eslint-disable-line no-undef
// const GRAPHQL_URL = 'http://192.168.1.151:4000/api/cpm/graphql';

/*
** Header builder
*/
const headers = (store, withoutAuth = false) => {
  let objHeaders = {
    Accept: 'application/vnd.app.v4+json',
  };

  if (!withoutAuth) {
    const { auth } = store.getState();

    if (auth && auth.token) {
      objHeaders = {
        ...objHeaders,
        Authorization: `Bearer ${auth.token}`,
      };
    }
  }

  return objHeaders;
};

/*
** HTTPS agent
*/
const httpsAgent = new https.Agent({
  rejectUnauthorized: false,
});

/*
** GET request generator
*/
const getApiGenerator = (store, next, name) => (route, params = {}, cbParams = null) => axios(
  {
    method: 'get',
    url: route,
    params,
    headers: headers(store),
    httpsAgent,
  },
).then((response) => {
  next({
    type: `${name}_SUCCESS`,
    data: response.data,
    ...cbParams,
  });
}).catch((error) => {
  logger.error('=========== GET ERROR', error);
  next({
    type: `${name}_ERROR`,
    error: buildError(error.response),
    ...cbParams,
  });
});

/*
** POST request generator
*/
const postApiGenerator = (store, next, name) => (route, data = {}, cbParams = null, onUploadProgress = null) => axios(
  {
    method: 'post',
    url: route,
    data,
    headers: headers(store),
    httpsAgent,
    onUploadProgress,
  },
).then((response) => {
  next({
    type: `${name}_SUCCESS`,
    data: response.data,
    ...cbParams,
  });
}).catch((error) => {
  logger.error('=========== POST ERROR', error);
  next({
    type: `${name}_ERROR`,
    error: buildError(error.response),
    ...cbParams,
  });
});

/*
** PUT request generator
*/
const putApiGenerator = (store, next, name) => (route, data = {}, cbParams = null) => axios(
  {
    method: 'put',
    url: route,
    data,
    headers: headers(store),
    httpsAgent,
  },
).then((response) => {
  next({
    type: `${name}_SUCCESS`,
    data: response.data,
    ...cbParams,
  });
}).catch((error) => {
  logger.error('=========== PUT ERROR', error);
  next({
    type: `${name}_ERROR`,
    error: buildError(error.response),
    ...cbParams,
  });
});

/*
** DELETE request generator
*/
const deleteApiGenerator = (store, next, name) => (route, params = {}, cbParams = null) => axios(
  {
    method: 'delete',
    url: route,
    params,
    headers: headers(store),
    httpsAgent,
  },
).then((response) => {
  next({
    type: `${name}_SUCCESS`,
    data: response.data,
    ...cbParams,
  });
}).catch((error) => {
  logger.error('=========== DELETE ERROR', error);
  next({
    type: `${name}_ERROR`,
    error: buildError(error.response),
    ...cbParams,
  });
});

/*
** GraphQL request generator
*/
const graphqlApiGenerator = (store, next, name) => (query, variables, cbParams = null, withoutAuth) => axios(
  {
    method: 'post',
    url: GRAPHQL_URL,
    headers: headers(store, withoutAuth),
    httpsAgent,
    data: {
      query,
      variables,
    },
  },
).then((response) => {
  // Server returns a HTTP 200 even when an error occured
  // So parse errors to call the good next action
  const { errors, data } = response.data;
  if (errors) {
    next({
      type: `${name}_ERROR`,
      useGraphQL: true,
      error: {
        errors,
      },
      data,
      ...cbParams,
    });
  } else {
    next({
      type: `${name}_SUCCESS`,
      useGraphQL: true,
      data,
      ...cbParams,
    });
  }
}).catch((error) => {
  logger.error('=========== GRAPHQL ERROR', error);
  // GraphQL API always returns a 200 HTTP code...
});

const apiService = (store) => (next) => (action) => {
  next(action);

  const getApi = getApiGenerator(store, next, action.type);
  const postApi = postApiGenerator(store, next, action.type);
  const putApi = putApiGenerator(store, next, action.type);
  const deleteApi = deleteApiGenerator(store, next, action.type);
  // GraphQL
  const graphqlApi = graphqlApiGenerator(store, next, action.type);

  switch (action.type) {
    /*
    ** Authentication
    */
    case POST_LOGIN: {
      // Action used for multiple products, with and without GraphQL...
      const { useGraphQL, data } = action;
      if (!useGraphQL) {
        // `data` contains directly an object {email, password}
        postApi(`${API_URL}/api/login`, data);
      } else {
        // `data` contains the query and data
        const { query, data: gqlData } = data;
        graphqlApi(query, buildGraphQLVariables(gqlData), null, true);
      }
      break;
    }
    case POST_LOGOUT: {
      // Action used for multiple products, with and without GraphQL...
      const { useGraphQL, data } = action;
      if (!useGraphQL) {
        postApi(`${API_URL}/api/logout`);
      } else {
        // `data` contains the query
        const { query } = data;
        graphqlApi(query);
      }
      break;
    }
    case POST_RECOVER_PASSWORD: {
      // Action used for multiple products, with and without GraphQL...
      const { useGraphQL, data } = action;
      if (!useGraphQL) {
        // `data` contains directly an object {email}
        postApi(`${API_URL}/api/recover_password`, data);
      } else {
        // `data` contains the query and data
        const { query, data: gqlData } = data;
        graphqlApi(query, buildGraphQLVariables(gqlData), null, true);
      }
      break;
    }
    case GET_RECOVER_PASSWORD_LINK: {
      // Action used for multiple products, with and without GraphQL...
      const { useGraphQL, data } = action;
      if (!useGraphQL) {
        // `data` contains directly an object {link}
        getApi(`${API_URL}/api/recover_password/${data.link}`);
      } else {
        // `data` contains the query and data
        const { query, data: gqlData } = data;
        graphqlApi(query, buildGraphQLVariables(gqlData), null, true);
      }
      break;
    }
    case UPDATE_RECOVER_PASSWORD_LINK: {
      // Action used for multiple products, with and without GraphQL...
      const { useGraphQL, data } = action;
      if (!useGraphQL) {
        // `data` contains directly an object {link, password}
        putApi(`${API_URL}/api/recover_password/${data.link}`, { password: data.password });
      } else {
        // `data` contains the query and data
        const { query, data: gqlData } = data;
        graphqlApi(query, buildGraphQLVariables(gqlData), null, true);
      }
      break;
    }

    /*
    ** Me
    */
    case GET_ME: {
      // Action used for multiple products, with and without GraphQL...
      const { useGraphQL, data } = action;
      if (!useGraphQL) {
        getApi(`${API_URL}/api/me`);
      } else {
        // `data` contains the query
        const { query } = data;
        graphqlApi(query);
      }
      break;
    }
    case UPDATE_ME:
      // Action used for multiple products, with and without GraphQL...
      const { useGraphQL, data } = action;
      if (!useGraphQL) {
        putApi(`${API_URL}/api/me`, action.data);
      } else {
        // `data` contains the query and data
        const { query, data: gqlData } = data;
        graphqlApi(query, buildGraphQLVariables(gqlData));
      }
      break;

    /*
    ** Operators
    */
    // Main
    case GET_OPERATORS:
      getApi(`${API_URL}/api/operators`);
      break;

    /*
    ** Equipments
    */
    // Main
    case GET_EQUIPMENTS_LIST:
      getApi(`${API_URL}/api/equipments`, buildListParams(action));
      break;

    /*
    ** Device models
    */
    case GET_DEVICE_MODELS:
      getApi(`${API_URL}/api/device_models`);
      break;

    /*
    ** Devices
    */
    // Main
    case GET_DEVICES_LIST:
      getApi(`${API_URL}/api/devices`, buildListParams(action), action.cbParams);
      break;
    case GET_DEVICES_AUTOCOMPLETE:
      getApi(`${API_URL}/api/devices`, buildListParams(action));
      break;
    case GET_DEVICE:
    case GET_DEVICE_INFO:
    case GET_DEVICE_LF:
      getApi(`${API_URL}/api/devices/${action.id}`, {}, action.cbParams);
      break;
    case GET_DEVICE_SYNC:
      getApi(`${API_URL}/api/devices/${action.id}/sync`, {}, action.cbParams);
      break;
    case SEND_CMD_DEVICE:
      postApi(`${API_URL}/api/devices/${action.id}/${action.cmd}`, {}, action.cbParams);
      break;
    case SEND_DEVICE_SMS:
      postApi(`${API_URL}/api/devices/${action.id}/sms`, action.sms, action.cbParams);
      break;
    case GET_DEVICE_SMS_HISTORY:
      getApi(`${API_URL}/api/devices/${action.id}/sms`);
      break;
    case GET_DEVICE_SMS_STATUS:
      getApi(`${API_URL}/api/devices/${action.id}/sms/${action.idSms}`);
      break;
    case DELETE_DEVICE:
      deleteApi(`${API_URL}/api/devices/${action.id}`);
      break;
    case UPDATE_DEVICE:
      putApi(`${API_URL}/api/devices/${action.id}`, action.data);
      break;
    case LINK_DEVICE_SIMCARD:
      postApi(`${API_URL}/api/devices/${action.id}/simcard`, action.data);
      break;
    case UNLINK_DEVICE_SIMCARD:
      deleteApi(`${API_URL}/api/devices/${action.id}/simcard`, action.data);
      break;
    // Config
    case UPDATE_DEVICE_CONFIG:
      putApi(`${API_URL}/api/devices/${action.id}/config`, action.data);
      break;
    // Logs
    case GET_DEVICE_LOGS_LIST:
      getApi(`${API_URL}/api/devices/${action.id}/logs`, buildListParams(action));
      break;
    // Distributions
    case GET_DEVICE_DISTRIBUTIONS_HISTORY:
      getApi(`${API_URL}/api/devices/${action.id}/distributions`);
      break;

    /*
    ** Device slaves
    */
    // Main
    case GET_DEVICE_SLAVES_LIST:
      getApi(`${API_URL}/api/device_slaves`, buildListParams(action), action.cbParams);
      break;
    case GET_DEVICE_SLAVE:
      getApi(`${API_URL}/api/device_slaves/${action.id}`, {}, action.cbParams);
      break;
    case DELETE_DEVICE_SLAVE:
      deleteApi(`${API_URL}/api/device_slaves/${action.id}`);
      break;
    case UPDATE_DEVICE_SLAVE:
      putApi(`${API_URL}/api/device_slaves/${action.id}`, action.data);
      break;

    /*
    ** Installations
    */
    // Main
    case GET_INSTALLATIONS_LIST:
      getApi(`${API_URL}/api/installations`, buildListParams(action), action.cbParams);
      break;
    case GET_INSTALLATIONS_AUTOCOMPLETE:
      getApi(`${API_URL}/api/installations`, buildListParams(action));
      break;
    case ADD_INSTALLATION:
      postApi(`${API_URL}/api/installations`, action.data);
      break;
    case GET_INSTALLATION:
    case GET_INSTALLATION_LF:
      getApi(`${API_URL}/api/installations/${action.id}`);
      break;
    case GET_DEVICE_INSTALLATION:
      getApi(`${API_URL}/api/installations/${action.idInstallation}`);
      break;
    case UPDATE_INSTALLATION:
      putApi(`${API_URL}/api/installations/${action.id}`, action.data);
      break;
    case DELETE_INSTALLATION:
      deleteApi(`${API_URL}/api/installations/${action.id}`);
      break;
    // Entities
    case GET_INSTALLATION_ENTITIES:
      getApi(`${API_URL}/api/installations/${action.id}/entities`);
      break;
    case ADD_INSTALLATION_ENTITY:
      postApi(`${API_URL}/api/installations/${action.id}/entities`, action.data);
      break;
    case DELETE_INSTALLATION_ENTITY:
      deleteApi(`${API_URL}/api/installations/${action.id}/entities/${action.idEntity}`);
      break;
    case UPDATE_INSTALLATION_ENTITY:
      putApi(`${API_URL}/api/installations/${action.id}/entities/${action.idEntity}`, action.data);
      break;
    // Doors
    case GET_INSTALLATION_DOORS:
      getApi(`${API_URL}/api/installations/${action.id}/doors`);
      break;
    case ADD_INSTALLATION_DOOR:
      postApi(`${API_URL}/api/installations/${action.id}/doors`, action.data);
      break;
    case DELETE_INSTALLATION_DOOR:
      deleteApi(`${API_URL}/api/installations/${action.id}/doors/${action.idDoor}`);
      break;
    case GET_INSTALLATION_DOOR:
      getApi(`${API_URL}/api/installations/${action.id}/doors/${action.idDoor}`);
      break;
    case UPDATE_INSTALLATION_DOOR:
      putApi(`${API_URL}/api/installations/${action.id}/doors/${action.idDoor}`, action.data);
      break;
    // Sources
    case GET_INSTALLATION_SOURCES:
      getApi(`${API_URL}/api/installations/${action.id}/sources`, {});
      break;
    case ADD_INSTALLATION_SOURCE:
      postApi(`${API_URL}/api/installations/${action.id}/sources`, action.data);
      break;
    case DELETE_INSTALLATION_SOURCE:
      deleteApi(`${API_URL}/api/installations/${action.id}/sources/${action.idSource}`);
      break;
    case GET_INSTALLATION_SOURCE:
      getApi(`${API_URL}/api/installations/${action.id}/sources/${action.idSource}`);
      break;
    case UPDATE_INSTALLATION_SOURCE:
      putApi(`${API_URL}/api/installations/${action.id}/sources/${action.idSource}`, action.data);
      break;
    // Devices
    case GET_INSTALLATION_DEVICES:
      getApi(`${API_URL}/api/installations/${action.id}/devices`, {}, action.cbParams);
      break;
    case ADD_INSTALLATION_DEVICE:
      postApi(`${API_URL}/api/installations/${action.id}/devices`, action.data);
      break;
    case DELETE_INSTALLATION_DEVICE:
      deleteApi(`${API_URL}/api/installations/${action.id}/devices/${action.idDevice}`);
      break;
    case GET_INSTALLATION_DEVICE:
      getApi(`${API_URL}/api/installations/${action.id}/devices/${action.idDevice}`);
      break;
    case UPDATE_INSTALLATION_DEVICE:
      putApi(`${API_URL}/api/installations/${action.id}/devices/${action.idDevice}`, action.data);
      break;
    case REPLACE_INSTALLATION_DEVICE:
      postApi(`${API_URL}/api/installations/${action.id}/devices/${action.idDevice}/replace/${action.idNewDevice}`, {});
      break;
    // Device slaves
    case ADD_INSTALLATION_DEVICE_SLAVE:
      postApi(`${API_URL}/api/installations/${action.id}/devices/${action.idDevice}/slaves`, action.data);
      break;
    case GET_INSTALLATION_DEVICE_SLAVE:
      getApi(`${API_URL}/api/installations/${action.id}/devices/${action.idDevice}/slaves/${action.idSlave}`);
      break;
    case UPDATE_INSTALLATION_DEVICE_SLAVE:
      putApi(`${API_URL}/api/installations/${action.id}/devices/${action.idDevice}/slaves/${action.idSlave}`, action.data);
      break;
    case DELETE_INSTALLATION_DEVICE_SLAVE:
      deleteApi(`${API_URL}/api/installations/${action.id}/devices/${action.idDevice}/slaves/${action.idSlave}`);
      break;
    case REPLACE_INSTALLATION_DEVICE_SLAVE:
      postApi(`${API_URL}/api/installations/${action.id}/devices/${action.idDevice}/slaves/${action.idSlave}/replace/${action.idNewSlave}`, {});
      break;
    // Scenarios
    case GET_INSTALLATION_SCENARIOS:
      getApi(`${API_URL}/api/installations/${action.id}/scenarios`);
      break;
    case ADD_INSTALLATION_SCENARIO:
      postApi(`${API_URL}/api/installations/${action.id}/scenarios`, action.data);
      break;
    case DELETE_INSTALLATION_SCENARIO:
      deleteApi(`${API_URL}/api/installations/${action.id}/scenarios/${action.idScenario}`);
      break;
    case GET_INSTALLATION_SCENARIO:
      getApi(`${API_URL}/api/installations/${action.id}/scenarios/${action.idScenario}`);
      break;
    case UPDATE_INSTALLATION_SCENARIO:
      putApi(`${API_URL}/api/installations/${action.id}/scenarios/${action.idScenario}`, action.data);
      break;
    case TRIGGER_INSTALLATION_SCENARIO:
      postApi(`${API_URL}/api/installations/${action.id}/scenarios/${action.idScenario}/trigger`, action.data, action.cbParams);
      break;
    // Customers
    case GET_INSTALLATION_CUSTOMERS_LIST:
      getApi(`${API_URL}/api/installations/${action.id}/customers`, buildListParams(action));
      break;
    case GET_INSTALLATION_CUSTOMERS_AUTOCOMPLETE:
      getApi(`${API_URL}/api/installations/${action.id}/customers`, buildListParams(action));
      break;
    case GET_INSTALLATION_CUSTOMER:
    case GET_INSTALLATION_CUSTOMER_LF:
      getApi(`${API_URL}/api/installations/${action.id}/customers/${action.idCustomer}`);
      break;
    case ADD_INSTALLATION_CUSTOMER:
      postApi(`${API_URL}/api/installations/${action.id}/customers`, action.data);
      break;
    case UPDATE_INSTALLATION_CUSTOMER:
    case UPDATE_INSTALLATION_CUSTOMER_STATE:
      putApi(`${API_URL}/api/installations/${action.id}/customers/${action.idCustomer}`, action.data);
      break;
    case DELETE_INSTALLATION_CUSTOMER:
      deleteApi(`${API_URL}/api/installations/${action.id}/customers/${action.idCustomer}`);
      break;
    case GET_INSTALLATION_CUSTOMER_RANDOM_UNIQUE_KEYPAD_CODE:
      getApi(`${API_URL}/api/installations/${action.id}/customers/random_unique_keypad_code`);
      break;
    case GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES:
      postApi(`${API_URL}/api/installations/${action.id}/customers/daily_codes`, action.data);
      break;
    case EXPORT_INSTALLATION_CUSTOMERS:
      getApi(`${API_URL}/api/installations/${action.id}/customers/export`);
      break;
    // Customer access ways
    case GET_INSTALLATION_CUSTOMER_ACCESSWAYS:
      getApi(`${API_URL}/api/installations/${action.id}/customers/${action.idCustomer}/access_ways`);
      break;
    case ADD_INSTALLATION_CUSTOMER_ACCESSWAY:
      postApi(`${API_URL}/api/installations/${action.id}/customers/${action.idCustomer}/access_ways`, action.data);
      break;
    case UPDATE_INSTALLATION_CUSTOMER_ACCESSWAY:
      putApi(`${API_URL}/api/installations/${action.id}/customers/${action.idCustomer}/access_ways/${action.idAccessWay}`, action.data);
      break;
    case DELETE_INSTALLATION_CUSTOMER_ACCESSWAY:
      deleteApi(`${API_URL}/api/installations/${action.id}/customers/${action.idCustomer}/access_ways/${action.idAccessWay}`);
      break;
    case TRIGGER_INSTALLATION_CUSTOMER_ACCESSWAY_RIGHT:
      postApi(`${API_URL}/api/installations/${action.id}/customers/${action.idCustomer}/access_ways/${action.idAccessWay}/rights/${action.idRight}/trigger`, {}, action.cbParams);
      break;
    // Plannings
    case GET_INSTALLATION_PLANNINGS:
      getApi(`${API_URL}/api/installations/${action.id}/plannings`, buildListParams(action));
      break;
    case GET_INSTALLATION_PLANNING:
      getApi(`${API_URL}/api/installations/${action.id}/plannings/${action.idPlanning}`);
      break;
    case ADD_INSTALLATION_PLANNING:
      postApi(`${API_URL}/api/installations/${action.id}/plannings`, action.data);
      break;
    case UPDATE_INSTALLATION_PLANNING:
      putApi(`${API_URL}/api/installations/${action.id}/plannings/${action.idPlanning}`, action.data);
      break;
    case DELETE_INSTALLATION_PLANNING:
      deleteApi(`${API_URL}/api/installations/${action.id}/plannings/${action.idPlanning}`);
      break;
    // Logs
    case GET_INSTALLATION_LOGS_LIST:
      getApi(`${API_URL}/api/installations/${action.id}/logs`, buildListParams(action));
      break;
    // Async operations
    case GET_INSTALLATION_ASYNC_OPERATIONS_LIST:
      getApi(`${API_URL}/api/installations/${action.id}/async_operations`, buildListParams(action), action.cbParams);
      break;
    case GET_INSTALLATION_ASYNC_OPERATION_HISTORY:
      getApi(`${API_URL}/api/installations/${action.id}/async_operations/${action.idAsyncOperation}`, buildListParams(action));
      break;

    /*
    ** Simcards
    */
    // Main
    case GET_SIMCARDS_LIST:
      getApi(`${API_URL}/api/simcards`, buildListParams(action), action.cbParams);
      break;
    case GET_SIMCARDS_AUTOCOMPLETE:
      getApi(`${API_URL}/api/simcards`, buildListParams(action));
      break;
    case ADD_SIMCARDS:
      postApi(`${API_URL}/api/simcards`, action.data);
      break;
    case IMPORT_SIMCARDS:
      postApi(`${API_URL}/api/simcards/import`, action.data);
      break;
    case GET_SIMCARD:
    case GET_SIMCARD_LF:
      getApi(`${API_URL}/api/simcards/${action.id}`);
      break;
    case UPDATE_SIMCARD:
      putApi(`${API_URL}/api/simcards/${action.id}`, action.data);
      break;
    case DELETE_SIMCARD:
      deleteApi(`${API_URL}/api/simcards/${action.id}`);
      break;
    case SYNCHRONIZE_SIMCARDS:
      postApi(`${API_URL}/api/simcards/synchronize`);
      break;
    case ACTIVATE_SIMCARDS:
      postApi(`${API_URL}/api/simcards/activate`, action.data);
      break;
    case LINK_SIMCARD_DEVICE:
      if (action.replacement) {
        putApi(`${API_URL}/api/simcards/${action.id}/device`, action.data);
      } else {
        postApi(`${API_URL}/api/simcards/${action.id}/device`, action.data);
      }
      break;
    case UNLINK_SIMCARD_DEVICE:
      deleteApi(`${API_URL}/api/simcards/${action.id}/device`, action.data);
      break;
    // Groups
    case GET_SIMCARD_GROUPS_LIST:
      getApi(`${API_URL}/api/simcard_groups`, buildListParams(action));
      break;
    case ADD_SIMCARD_GROUP:
      postApi(`${API_URL}/api/simcard_groups`, action.data);
      break;
    case GET_SIMCARD_GROUP:
      getApi(`${API_URL}/api/simcard_groups/${action.id}`);
      break;
    case ADD_SIMCARD_GROUP_APN:
      postApi(`${API_URL}/api/simcard_groups/${action.id}/apn`, action.data);
      break;
    case DELETE_SIMCARD_GROUP_APN:
      deleteApi(`${API_URL}/api/simcard_groups/${action.id}/apn`, action.data);
      break;
    // APNs
    case GET_APNS_LIST:
      getApi(`${API_URL}/api/apns`, buildListParams(action));
      break;
    case ADD_APN:
      postApi(`${API_URL}/api/apns`, action.data);
      break;

    /*
    ** Companies
    */
    // Main
    case GET_COMPANIES:
      getApi(`${API_URL}/api/companies`);
      break;
    case ADD_COMPANY:
      postApi(`${API_URL}/api/companies`, action.data);
      break;
    case DELETE_COMPANY:
      deleteApi(`${API_URL}/api/companies/${action.id}`);
      break;
    case GET_COMPANY:
      getApi(`${API_URL}/api/companies/${action.id}`);
      break;
    case UPDATE_COMPANY:
      putApi(`${API_URL}/api/companies/${action.id}`, action.data);
      break;

    /*
    ** Users
    */
    // Main
    case GET_USERS_LIST:
      getApi(`${API_URL}/api/users`, buildListParams(action));
      break;
    case GET_USER:
      getApi(`${API_URL}/api/users/${action.id}`);
      break;
    case ADD_USER:
      postApi(`${API_URL}/api/users`, action.data);
      break;
    case UPDATE_USER:
      putApi(`${API_URL}/api/users/${action.id}`, action.data);
      break;
    case DELETE_USER:
      deleteApi(`${API_URL}/api/users/${action.id}`);
      break;
    // Profiles
    case GET_PROFILES_LIST:
      getApi(`${API_URL}/api/profiles`, buildListParams(action));
      break;
    case GET_PROFILES_AUTOCOMPLETE:
      getApi(`${API_URL}/api/profiles`, buildListParams(action));
      break;
    case GET_PROFILE:
    case GET_PROFILE_LF:
      getApi(`${API_URL}/api/profiles/${action.id}`);
      break;
    case ADD_PROFILE:
      postApi(`${API_URL}/api/profiles`, action.data);
      break;
    case UPDATE_PROFILE:
      putApi(`${API_URL}/api/profiles/${action.id}`, action.data);
      break;
    case DELETE_PROFILE:
      deleteApi(`${API_URL}/api/profiles/${action.id}`);
      break;
    // Permissions
    case GET_PERMISSIONS:
      getApi(`${API_URL}/api/permissions`);
      break;
    // Alertings
    case GET_ALERTINGS:
      getApi(`${API_URL}/api/alertings`);
      break;

    /*
    ** Production
    */
    // Device batches
    case GET_DEVICE_BATCHES:
      getApi(`${API_URL}/api/production/device_batches`);
      break;
    case ADD_DEVICE_BATCH:
      postApi(`${API_URL}/api/production/device_batches`, action.data);
      break;
    case GET_DEVICE_BATCH:
      getApi(`${API_URL}/api/production/device_batches/${action.id}`);
      break;
    case UPDATE_DEVICE_BATCH:
      putApi(`${API_URL}/api/production/device_batches/${action.id}`, action.data);
      break;
    case GET_DEVICE_BATCH_AUTHOR:
      getApi(`${API_URL}/api/users/${action.idAuthor}`, {}, { id: action.id });
      break;
    case GET_DEVICE_BATCH_COMMITTER:
      getApi(`${API_URL}/api/users/${action.idCommitter}`, {}, { id: action.id });
      break;
    case GET_DEVICE_BATCH_DISTRIBUTION:
      getApi(`${API_URL}/api/distributions/${action.distribution.id}`, {}, { id: action.id });
      break;
    case GET_DEVICE_BATCH_ARCHIVE:
      getApi(`${API_URL}/api/production/device_batches/${action.id}/archive`);
      break;

    /*
    ** Updates
    */
    // Distributions
    case GET_DISTRIBUTIONS_LIST:
      getApi(`${API_URL}/api/distributions`, buildListParams(action));
      break;
    case GET_DISTRIBUTIONS_AUTOCOMPLETE:
      getApi(`${API_URL}/api/distributions`, buildListParams(action));
      break;
    case GET_DISTRIBUTION:
    case GET_DISTRIBUTION_LF:
      getApi(`${API_URL}/api/distributions/${action.id}`);
      break;
    case ADD_DISTRIBUTION:
      postApi(`${API_URL}/api/distributions`, action.data, null, action.onUploadProgress);
      break;
    case UPDATE_DISTRIBUTION:
      putApi(`${API_URL}/api/distributions/${action.id}`, action.data);
      break;
    case DELETE_DISTRIBUTION:
      deleteApi(`${API_URL}/api/distributions/${action.id}`);
      break;
    case GET_DISTRIBUTION_ARCHIVE:
      getApi(`${API_URL}/api/distributions/${action.id}/archive`);
      break;
    // Rollouts
    case GET_ROLLOUTS_LIST:
      getApi(`${API_URL}/api/rollouts`, buildListParams(action));
      break;
    case GET_ROLLOUT:
      getApi(`${API_URL}/api/rollouts/${action.id}`);
      break;
    case ADD_ROLLOUT:
      postApi(`${API_URL}/api/rollouts`, action.data);
      break;
    case DELETE_ROLLOUT:
      deleteApi(`${API_URL}/api/rollouts/${action.id}`);
      break;
    case GET_ROLLOUT_DEVICES_LIST:
      getApi(`${API_URL}/api/rollouts/${action.id}/devices`, buildListParams(action));
      break;

    /*
    ** CPM
    */
    // Carparks
    case CPM_GET_CARPARK_BY_SLUG:
    case CPM_GET_SLUG_BY_DOMAIN:
    case CPM_CHECK_CUSTOMER_ACCOUNT_LINK:
    case CPM_VALIDATE_CUSTOMER_ACCOUNT_LINK:
    case CPM_VALIDATE_ACCOUNT_LINK:
    case CPM_SEARCH_ON_DEMAND_ACCESS:
    case POST_LOGIN_BY_MAGIC_LINK:
    case CPM_SIGN_UP:
      graphqlApi(action.query, buildGraphQLVariables(action.data), null, true);
      break;
    case CPM_GET_PRICE_RULES:
    case CPM_GET_MY_BOOKINGS_LIST:
    case CPM_GET_ACCOUNTS_LIST:
    case CPM_LIST_WORKSPACES:
    case CPM_LIST_SLUGS:
      graphqlApi(action.query, buildGraphQLListParams(action.listParams));
      break;
    case CPM_GET_CARPARK_ACTIVITY_ARRIVALS_LIST:
    case CPM_GET_CARPARK_ACTIVITY_DEPARTURES_LIST:
    case CPM_GET_CARPARK_ACTIVITY_ENTRIES_LIST:
    case CPM_GET_CARPARK_ACTIVITY_EXITS_LIST:
    case CPM_GET_CARPARK_PLANNINGS:
    case CPM_GET_CARPARK_PARKING_CATEGORIES:
    case CPM_GET_CARPARK_PRICE_GRIDS:
    case CPM_GET_CARPARK_CUSTOMERS_LIST:
    case CPM_GET_CARPARK_CUSTOMERS_AUTOCOMPLETE:
    case CPM_GET_CARPARK_PARKINGS_LIST:
    case CPM_GET_CARPARK_BOOKINGS_LIST:
    case CPM_GET_CARPARK_PARKINGS_AUTOCOMPLETE:
    case CPM_GET_CARPARK_ON_DEMAND_LIST:
    case CPM_GET_CARPARK_ACCESSES_LIST:
    case CPM_GET_CARPARK_INVOICES_LIST:
    case CPM_GET_ONEPARK_BOOKINGS_LIST:
    case CPM_DOWNLOAD_CARPARK_INVOICES:
    case CPM_LIST_SERVICE_FEE_RULES:
    case CPM_LIST_WORKSPACE_GROUPS:
    case CPM_GET_PARTNERS_LIST:
    case CPM_GET_CARPARK_WORKSPACE_GROUPS:
      graphqlApi(action.query, {
        ...buildGraphQLVariables(action.data),
        ...buildGraphQLListParams(action.listParams),
      });
      break;
    case CPM_GET_CARPARKS_AUTOCOMPLETE:
    case CPM_GET_CARPARKS_LIST:
    case CPM_COUNT_CARPARKS:
    case CPM_GET_CARPARK_CUSTOMER_PARKINGS_LIST:
    case CPM_GET_CARPARK_CUSTOMER_BOOKINGS_LIST:
    case CPM_GET_CARPARK_CUSTOMER_OLD_PARKINGS_LIST:
    case CPM_GET_CARPARK_CUSTOMER_ACCESSES_LIST:
    case CPM_GET_CARPARK_PARKING_ACCESSES_LIST:
      graphqlApi(action.query, {
        ...buildGraphQLVariables(action.data),
        ...buildGraphQLListParams(action.listParams),
      }, action.cbParams);
      break;
    case CPM_GET_CARPARK:
    case CPM_GET_CARPARK_DEFAULT_SLUG:
    case CPM_GET_CARPARK_SYNCHRONIZATION_STATUSES:
    case CPM_UPDATE_CARPARK:
    case CPM_UPDATE_CARPARK_CONTACT:
    case CPM_GET_CARPARK_UNIQUE_KEYPAD_CODE:
    case CPM_UPDATE_CARPARK_BOOKING_SETTINGS:
    case CPM_UPDATE_CARPARK_GENERAL_SETTINGS:
    case CPM_UPDATE_CARPARK_ON_DEMAND_SETTINGS:
    case CPM_UPDATE_CARPARK_LICENSE_PLATE_SETTINGS:
    case CPM_UPDATE_CARPARK_SPACES_SETTINGS:
    case CPM_UPDATE_CARPARK_FINANCIAL_INFORMATION:
    case CPM_UPDATE_CARPARK_PARTNER:
    case CPM_UPDATE_CARPARK_WORKSPACE_GROUPS:
    case CPM_GET_CARPARK_PLANNING:
    case CPM_ADD_CARPARK_PLANNING:
    case CPM_UPDATE_CARPARK_PLANNING:
    case CPM_DELETE_CARPARK_PLANNING:
    case CPM_ADD_CARPARK_PARKING_CATEGORY:
    case CPM_UPDATE_CARPARK_PARKING_CATEGORY:
    case CPM_DELETE_CARPARK_PARKING_CATEGORY:
    case CPM_SEND_CARPARK_PRICE_GRID_TO_CUSTOMER:
    case CPM_ADD_CARPARK_PRICE_GRID:
    case CPM_UPDATE_CARPARK_PRICE_GRID:
    case CPM_GET_CARPARK_CUSTOMER:
    case CPM_GET_CARPARK_CUSTOMER_LF:
    case CPM_ADD_CARPARK_CUSTOMER:
    case CPM_UPDATE_CARPARK_CUSTOMER:
    case CPM_DELETE_CARPARK_CUSTOMER:
    case CPM_CREATE_CARPARK_CUSTOMER_ACCOUNT:
    case CPM_DELETE_CARPARK_CUSTOMER_ACCOUNT:
    case CPM_GET_CARPARK_PARKING_LF:
    case CPM_UPDATE_CARPARK_PARKING_STATE:
    case CPM_CATEGORIZE_CARPARK_ON_DEMAND:
    case CPM_DELETE_CARPARK_ON_DEMAND:
    case CPM_UPDATE_CARPARK_ON_DEMAND_ACCESS_STATE:
    case CPM_LIST_MY_CARPARK_BOOKING_OPTIONS:
    case CPM_SEARCH_CARPARK_BOOKING_OFFER:
    case CPM_SEARCH_CARPARK_BOOKING_EXTENSION_OFFER:
    case CPM_BOOK_CARPARK:
    case CPM_EXTEND_BOOK_CARPARK:
    case CPM_PAY_BOOKING_OVERSTAY:
    case CPM_CANCEL_MY_BOOKING:
    case CPM_CANCEL_CARPARK_BOOKING:
    case CPM_SET_ACCOUNT_STATUS:
    case CPM_ADD_CARPARK_BOOKING:
    case CPM_UPDATE_CARPARK_BOOKING:
    case CPM_UPDATE_CARPARK_BOOKING_STATE:
    case CPM_SEND_BOOKING_PAYMENT_LINK:
    case CPM_REFUND_BOOKING:
    case CPM_REFUND_ON_DEMAND_ACCESS:
    case CPM_REFUND_PURCHASE:
    case CPM_GET_ON_DEMAND_ACCESS:
    case CPM_SELF_CHECKOUT_ON_DEMAND_ACCESS:
    case CPM_EXTEND_ON_DEMAND_ACCESS:
    case CPM_PAY_ON_DEMAND_ACCESS_OVERSTAY:
    case CPM_CREATE_PARTNER:
    case CPM_UPDATE_PARTNER_FINANCIAL_INFORMATION:
    case CPM_DOWNLOAD_CARPARK_INVOICE:
    case CPM_DOWNLOAD_MY_INVOICE:
    case CPM_UPDATE_CARPARK_INVOICE:
    case CPM_RESEND_BOOKING_CONFIRMATION_EMAIL:
    case CPM_CREATE_ON_DEMAND_ACCESS:
    case CPM_TERMINATE_ON_DEMAND_ACCESS:
    case CPM_UPDATE_ON_DEMAND_ACCESS_CUSTOMER:
    case CPM_UPDATE_ON_DEMAND_ACCESS:
    case CPM_DECLARE_FINAL_EXIT_FOR_TEMPORARY_ON_DEMAND_ACCESS:
    case CPM_DECLARE_FINAL_EXIT_FOR_BOOKING:
    case CPM_CREATE_WORKSPACE:
    case CPM_CREATE_WORKSPACE_GROUP:
    case CPM_UPDATE_WORKSPACE:
    case CPM_UPDATE_WORKSPACE_GROUP:
    case CPM_CREATE_SLUG:
    case CPM_DELETE_SLUG:
    case CPM_UPDATE_SLUG:
    case CPM_GET_WORKSPACE_GROUP:
    case CPM_GET_WORKSPACE:
    case CPM_INITIATE_PAYMENT:
    case CPM_DELETE_MY_PAYMENT_METHOD:
    case CPM_GET_MY_BOOKING:
    case CPM_GET_UPDATED_MY_BOOKING:
    case CPM_GET_OFFER:
    case CPM_CREATE_SERVICE_FEE_RULE:
    case CPM_DELETE_SERVICE_FEE_RULE:
    case CPM_UPDATE_SERVICE_FEE_RULE:
    case CPM_GET_CARPARK_METRICS_REVENUES_REPORT:
      graphqlApi(action.query, buildGraphQLVariables(action.data));
      break;
    case CPM_TRIGGER_CARPARK_DOOR:
    case CPM_GET_CARPARK_REVENUES_SUMMARY:
    case CPM_ADD_CARPARK_PRICE_GRID_TO_PARKING_CATEGORY:
    case CPM_DELETE_CARPARK_PRICE_GRID_FROM_PARKING_CATEGORY:
    case CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_LIVE:
    case CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PERIOD:
    case CPM_GET_CARPARK_METRICS_OCCUPANCY_RATE_PREDICTED:
    case CPM_GET_CARPARK_METRICS_ACCESSES:
    case CPM_GET_CARPARK_METRICS_REVENUES:
    case CPM_ADD_CARPARK_PARKING:
    case CPM_DELETE_CARPARK_PARKING:
    case CPM_UPDATE_CARPARK_PARKING:
      graphqlApi(action.query, buildGraphQLVariables(action.data), action.cbParams);
      break;
    case CPM_GET_SERVICE_FEE_RULE:
      graphqlApi(action.query, {
        ...buildGraphQLVariables(action.data),
        ...buildGraphQLListParams(
          action.carparksListParams,
          {
            paginationKey: {
              rootKey: 'carparksPagination',
              pageNumberKey: 'pageNumber',
              pageSizeKey: 'pageSize',
            },
            sortKey: 'carparksSort',
            searchKey: 'carparksSearch',
          },
        ),
      });
      break;

    default:
      break;
  }
};

export default apiService;



// WEBPACK FOOTER //
// ./middlewares/apiService.js